import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from '@mui/material';
import { getListaServicosPrestados } from 'api/forms/pacote_formularios.api';
import ActionButtonsFormularioAgricultura from 'components/forms/ActionButtonsFormularioAgricultura';
import { ContainerForm } from 'components/shared/container_form';
import { useEffect } from 'react';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
const Step4: React.FC = () => {
  const {
    formulario,
    listaServicosPrestados,
    setListaServicosPrestados,
    setPartialForm,
  } = useFormularioSecretariaMunicipalAgriculturaStore();

  const handleGetListaServicosPrestados = async () => {
    const data = await getListaServicosPrestados();
    setListaServicosPrestados(data.dados || []);
  };

  // preencheu todos os campos?
  const preencheuTodosCampos =
    formulario?.tipo_publicacao !== null &&
    (formulario?.orcamento_secretaria || 0) > 0 &&
    (formulario?.porcentagem_orcamento_ano_corrente || 0) > 0;

  const formularioInativo =
    formulario?.fundo_municipal_agricultura_familiar === false ||
    preencheuTodosCampos;

  const handleChangeServicoPrestado = (uuid: string) => {
    if (!formulario?.servicos_prestados.includes(uuid)) {
      const newServicosPrestados = [
        ...(formulario?.servicos_prestados || []),
        uuid,
      ];
      setPartialForm('servicos_prestados', newServicosPrestados);
    } else {
      const newServicosPrestados = formulario?.servicos_prestados?.filter(
        (item) => item !== uuid,
      );
      setPartialForm('servicos_prestados', newServicosPrestados);
    }
  };

  const handleClearServicosPrestados = () => {
    setPartialForm('servicos_prestados', []);
  };

  useEffect(() => {
    handleGetListaServicosPrestados();
  }, []);
  return (
    <>
      <ContainerForm title='Informações Complementares'>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              Quais são os serviços prestados por essa Secretária/Órgão
              Municipal de Agricultura Familiar?
            </FormLabel>

            <FormControlLabel
              control={<Checkbox />}
              label='Nenhum serviço é prestado pela Secretaria Municipal de Agricultura'
              checked={formulario?.servicos_prestados.length === 0}
              onChange={() => handleClearServicosPrestados()}
            />

            {listaServicosPrestados.map((item, index) => (
              <FormControlLabel
                key={item.uuid}
                control={<Checkbox />}
                label={item.nome_servico}
                checked={formulario?.servicos_prestados?.includes(item.uuid)}
                onChange={() => handleChangeServicoPrestado(item.uuid)}
              />
            ))}
          </FormControl>
        </Box>
        <ActionButtonsFormularioAgricultura disabled={!formularioInativo} />
      </ContainerForm>
    </>
  );
};

export default Step4;
